import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import * as release from '@webapp/sdk/release';
import { Action } from 'redux';
import {
  UpdatedTakedownRelease,
  UpdatedTakedownReleaseSuccess,
  UpdatedTakedownReleaseError,
} from '../action-creators';
import { UPDATED_TAKEDOWN_RELEASE } from '../actions';

export const updatedTakedownReleaseEpic = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<Action, UpdatedTakedownRelease>(UPDATED_TAKEDOWN_RELEASE),
    mergeMap(async (action) => {
      try {
        let takedownBody = {
          releaseId: action.releaseId,
          stores: action.takedownStores.map((store) => {
            return { id: store.id, name: store.name };
          }),
        };
        await release.updatedTakedown(
          action.artistId,
          action.releaseId,
          takedownBody
        );

        return new UpdatedTakedownReleaseSuccess(
          action.artistId,
          action.releaseId,
          action.takedownStores
        );
      } catch (err) {
        return new UpdatedTakedownReleaseError(err?.message);
      }
    })
  );
